import type { TApiException } from '@shared/types';

// Mirrors the AI budget members of backend/src/common/api.exceptions.ts.
const AI_BUDGET_REFUSAL_IDS = new Set(['AI_BUDGET_UNCONFIGURED', 'AI_BUDGET_EXPIRED', 'AI_BUDGET_EXHAUSTED']);

const isAiBudgetRefusal = (apiError: TApiException | null): boolean =>
  Boolean(apiError?.id && AI_BUDGET_REFUSAL_IDS.has(apiError.id));

export default isAiBudgetRefusal;
